
import React, { useState, useEffect, useContext } from 'react'
import AdminSideBar from "../../components/adminSideBar/AdminSideBar";
import { AuthContext } from '../../context/authContext/AuthContext';
import { useNavigate, useParams } from 'react-router-dom';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import { EnvoieContext } from '../../context/envoieContext/EnvoieContext';
import { getOneEnvoie, simulateGetCost, updateEnvoie } from '../../context/envoieContext/apiCalls';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import { communes, currentStatusEnvois, NatureEnvois, typeDeliveries, typeEnvois, typeRamassages, wilayas } from '../../data';
import FormRadio from '../../components/formRadio/FormRadio';
import FormInput from '../../components/formInput/FormInput';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';


function UpdateEnvoie() {
    const [typeEnvoie, setTypeEnvoie] = useState("");
    const [typeDelivery, setTypeDelivery] = useState("");
    const [typeRamassage, setTypeRamassage] = useState("");
    const [errorBox, setErrorBox] = useState("");
    const { user } = useContext(AuthContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { dispatch, envoie, isFetchingGet, errorGet, envoieUpdate, isFetchingUpdate, errorUpdate, isFetchingSimulate, cost } = useContext(EnvoieContext);

    const { id } = useParams();
    const navigate = useNavigate();

    /*  Sender */
    const [nomSender, setNomSender] = useState("");
    const [emailSender, setEmailSender] = useState("");
    const [tel1Sender, setTel1Sender] = useState("");
    const [tel2Sender, setTel2Sender] = useState("");
    const [wilayaSender, setWilayaSender] = useState(wilayas[0]);
    const [agenceSender, setAgenceSender] = useState({ nom: "Choisir Agence", id: 0, });
    const [addressSender, setAddressSender] = useState("");

    /*  Receiver  */
    const [nomReceiver, setNomReceiver] = useState("");
    const [prenomReceiver, setPrenomReceiver] = useState("");
    const [emailReceiver, setEmailReceiver] = useState("");
    const [tel1Receiver, setTel1Receiver] = useState("");
    const [tel2Receiver, setTel2Receiver] = useState("");
    const [wilayaReceiver, setWilayaReceiver] = useState(wilayas[0]);
    const [communeReceiver, setCommuneReceiver] = useState(communes[0][0]);
    const [addressReceiver, setAddressReceiver] = useState("");
    const [agenceReceiver, setAgenceReceiver] = useState({ nom: "Choisir Agence", id: 0, });

    /*  Details  */
    const [description, setDescription] = useState("");
    const [number, setNumber] = useState("");
    const [montant, setMontant] = useState("");
    const [nature, setNature] = useState(NatureEnvois[0]);
    const [weight, setWeight] = useState("");
    const [result, setResult] = useState("");


    useEffect(() => {
        getOneEnvoie(dispatch, id);
    }, [id])

    useEffect(() => {
        getAgencesByWilaya(dispatchAgence);
    }, [])

    useEffect(() => {
        setAgenceSender({ nom: "Choisir Agence", id: 0, });
    }, [wilayaSender])

    useEffect(() => {
        setCommuneReceiver(communes[wilayaReceiver.id][0]);
        setAgenceReceiver({ nom: "Choisir Agence", id: 0, });
    }, [wilayaReceiver])

    useEffect(() => {
        setErrorBox('');
        setResult(`${cost}`);
    }, [cost])

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }, [errorBox])

    useEffect(() => {
        if (errorUpdate != false) {
            setErrorBox(errorUpdate);
        }
    }, [errorUpdate])

    useEffect(() => {
        if (Object.keys(envoieUpdate).length !== 0) {
            setErrorBox('');
            navigate(`/envois`);
        }
    }, [envoieUpdate])

    useEffect(() => {
        if (envoie && Object.keys(envoie).length !== 0) {
            setTypeEnvoie(typeEnvois.filter(item => item.id === envoie.typeEnvoie)[0]);
            setTypeDelivery(typeDeliveries.filter(item => item.id === envoie.typeDelivery)[0]);

            /* Sender */
            setNomSender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.nom || "";
                // } else {
                //     return envoie.User.Userinfo.nom || "";
                // }
                return envoie.nomDeparture
            });
            setEmailSender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.email || "";
                // } else {
                //     return envoie.User.Userinfo.email || "";
                // }
                return envoie.emailDeparture
            });
            setTel1Sender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.tel1 || "";
                // } else {
                //     return envoie.User.Userinfo.tel1 || "";
                // }
                return envoie.tel1Departure
            });
            setTel2Sender(() => {
                // if (envoie.Entreprise) {
                //     return envoie.Entreprise.tel2 || "";
                // } else {
                //     return envoie.User.Userinfo.tel2 || "";
                // }
                return envoie.tel2Departure
            });
            setWilayaSender(() => {
                return wilayas.filter(item => item.id === envoie.wilayaDeparture)[0] || wilayas[0];
            });

            setTypeRamassage(typeRamassages.filter(item => item.id === envoie.typeRamassage)[0]);
            setAddressSender(envoie.addressDeparture || "");
            envoie.agenceDeparture && setAgenceSender(agencesByWilaya.filter(item => item.id === envoie.agenceDeparture)[0])

            /* Receiver */
            setNomReceiver(envoie.nomArrived || "");
            setEmailReceiver(envoie.emailArrived || "");
            setTel1Receiver(envoie.tel1Arrived || "");
            setTel2Receiver(envoie.tel2Arrived || "");
            setWilayaReceiver(wilayas.filter(item => item.id === envoie.wilayaArrived)[0]);
            setCommuneReceiver(communes[envoie.wilayaArrived].filter(item => item.id === envoie.communeArrived)[0]);
            setAddressReceiver(envoie.addressArrived || "");
            envoie.agenceArrived && setAgenceReceiver(agencesByWilaya.filter(item => item.id === envoie.agenceArrived)[0]);

            /*  Details  */
            setDescription(envoie.description);
            setNumber(envoie.numero);
            setMontant(`${envoie.montant}`);
            setNature(NatureEnvois.filter(item => item.id === envoie.nature)[0]);
            setWeight(envoie.weight);
        }
    }, [envoie])

    useEffect(() => {
        if (wilayaSender.id === 0 || wilayaReceiver.id === 0 || weight.trim() == "" || isNaN(weight)) {
            setResult("");
        } else {
            simulateGetCost(dispatch, wilayaSender.id, wilayaReceiver.id, weight, typeEnvoie.id, typeDelivery.id, typeRamassage.id, user.entreprise ? user.entreprise.id : null);
        }
    }, [wilayaSender, wilayaReceiver, weight, typeEnvoie, typeDelivery, typeRamassage])

    /*  Functions  */
    const handleUpdateEnvoie = (e) => {
        e.preventDefault();
        if (nomSender.trim() == "") {
            setErrorBox(`Vous devez compléter le Nom d'expéditeur`);
            return;
        }
        if (tel1Sender.trim() == "") {
            setErrorBox(`Vous devez compléter le Tel 1 d'expéditeur`);
            return;
        }
        if (wilayaSender.id === 0) {
            setErrorBox(`Vous devez compléter la Wilaya d'expéditeur`);
            return;
        }
        if (typeRamassage.id === 2) {
            if (agenceSender.id === 0) {
                setErrorBox(`Vous devez compléter l'Agence de Départ`);
                return;
            }
        } else {
            if (addressSender.trim() == "") {
                setErrorBox(`Vous devez compléter l'Adresse d'expéditeur`);
                return;
            }
        }
        if (nomReceiver.trim() == "") {
            setErrorBox(`Vous devez compléter le Nom de destinataire`);
            return;
        }
        if (tel1Receiver.trim() == "") {
            setErrorBox(`Vous devez compléter le Tel 1 de destinataire`);
            return;
        }
        if (wilayaReceiver.id === 0) {
            setErrorBox(`Vous devez compléter la wilaya de destinataire`);
            return;
        }
        if (typeDelivery.id === 2) {
            if (agenceReceiver.id === 0) {
                setErrorBox(`Vous devez compléter l'Agence d'Arrivé`);
                return;
            }
        } else {
            if (communeReceiver.id === 0) {
                setErrorBox(`Vous devez compléter la commune de destinataire`);
                return;
            }
            if (addressReceiver.trim() == "") {
                setErrorBox(`Vous devez compléter l'Adresse de destinataire`);
                return;
            }
        }
        if (description.trim() == "") {
            setErrorBox(`Vous devez compléter la Description`);
            return;
        }
        if (montant.trim() == "") {
            setErrorBox(`Vous devez compléter le Montant`);
            return;
        }
        if (isNaN(montant)) {
            setErrorBox(`Montant doit etre un nombre`);
            return;
        }
        if (weight.trim() == "") {
            setErrorBox(`Vous devez compléter le Poids en KG`);
            return;
        }
        if (isNaN(weight)) {
            setErrorBox(`Le poids doit etre un nombre`);
            return;
        }

        updateEnvoie(
            dispatch, id, typeEnvoie.id, typeDelivery.id, typeRamassage.id, wilayaSender.id, agenceSender.id, addressSender,nomSender,emailSender,tel1Sender,tel2Sender, 
            nomReceiver, prenomReceiver, emailReceiver, tel1Receiver, tel2Receiver, wilayaReceiver.id,communeReceiver.id, addressReceiver, agenceReceiver.id, 
            description, number, montant, nature.id, weight);

    }


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="envoie" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Modifier Envoie : {envoie.currentStatus && (currentStatusEnvois.filter(item => item.id === envoie.currentStatus)[0]['nom'])}-{envoie?.tracking}</span>
                    {/* <span>Modifier Envoie : NWE-{envoie?.tracking}</span> */}
                </div>

                {errorBox !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorBox}</div>)}

                {
                    errorGet ? <ErrorComponent error={errorGet} /> : (
                        isFetchingGet ? <LoadingComponent /> : (
                            !envoie ? <span className='no-data'>Envoie Introuvable</span> : (
                                <div className="content envoie">
                                    <div className="box">
                                        <div className="box-title">Type d'Envoie :</div>
                                        <div className="box-content">
                                            <FormRadio data={typeEnvois} itemChoisir={typeEnvoie} setItemChoisir={setTypeEnvoie} name='type-envoie' />
                                        </div>
                                    </div>
                                    <div className='big-box'>
                                        {/* Sender */}
                                        <div className="box">
                                            <div className="box-title">Expéditeur :</div>
                                            <div className="box-content">
                                                <div className='side-to-side-envoie'>
                                                    <FormInput label='Nom *' itemInput={nomSender} setItemInput={setNomSender} auth />
                                                </div>
                                                <FormInput label='Email' itemInput={emailSender} setItemInput={setEmailSender} auth />
                                                <div className='side-to-side-envoie' >
                                                    <FormInput label='Tel 1 *' itemInput={tel1Sender} setItemInput={setTel1Sender} auth istype='number' />
                                                    <FormInput label='Tel 2' itemInput={tel2Sender} setItemInput={setTel2Sender} auth istype='number' />
                                                </div>
                                                <DropDownComponent data={wilayas} itemChoisir={wilayaSender} setItemChoisir={setWilayaSender} />
                                                <FormRadio data={typeRamassages} itemChoisir={typeRamassage} setItemChoisir={setTypeRamassage} name='type-ramassage' />
                                                {
                                                    typeRamassage.id === 2 ? (
                                                        <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya.filter(item => item.wilaya === wilayaSender.id)]} itemChoisir={agenceSender} setItemChoisir={setAgenceSender} />
                                                    ) : (
                                                        <FormInput label='Adresse Départ *' itemInput={addressSender} setItemInput={setAddressSender} auth />
                                                    )
                                                }
                                            </div>
                                        </div>
                                        {/* Receiver */}
                                        <div className="box">
                                            <div className="box-title">Destinataire :</div>
                                            <div className="box-content">
                                                <div className='side-to-side-envoie'>
                                                    <FormInput label='Nom *' itemInput={nomReceiver} setItemInput={setNomReceiver} auth />
                                                    {/* <FormInput label='Prenom *' itemInput={prenomReceiver} setItemInput={setPrenomReceiver} auth /> */}
                                                </div>
                                                <FormInput label='Email' itemInput={emailReceiver} setItemInput={setEmailReceiver} auth />
                                                <div className='side-to-side-envoie'>
                                                    <FormInput label='Tel 1 *' itemInput={tel1Receiver} setItemInput={setTel1Receiver} auth istype='number' />
                                                    <FormInput label='Tel 2' itemInput={tel2Receiver} setItemInput={setTel2Receiver} auth istype='number' />
                                                </div>
                                                <DropDownComponent data={wilayas} itemChoisir={wilayaReceiver} setItemChoisir={setWilayaReceiver} />
                                                <FormRadio data={typeDeliveries} itemChoisir={typeDelivery} setItemChoisir={setTypeDelivery} name='type-delivery' />
                                                {
                                                    typeDelivery.id === 1 ? (
                                                        <>
                                                            <DropDownComponent data={communes[wilayaReceiver.id]} itemChoisir={communeReceiver} setItemChoisir={setCommuneReceiver} />
                                                            <FormInput label='Adresse *' itemInput={addressReceiver} setItemInput={setAddressReceiver} auth />
                                                        </>
                                                    ) : (
                                                        <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...(agencesByWilaya.filter(item => item.wilaya === wilayaReceiver.id))]} itemChoisir={agenceReceiver} setItemChoisir={setAgenceReceiver} />
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {/* Details */}
                                    <div className="box">
                                        <div className="box-title">Détails :</div>
                                        <div className="box-content">
                                            <FormInput label='Description *' itemInput={description} setItemInput={setDescription} auth />
                                            <div className='side-to-side-envoie'>
                                                <FormInput label='Numero' itemInput={number} setItemInput={setNumber} auth />
                                                <FormInput label='Montant *' itemInput={montant} setItemInput={setMontant} auth />
                                            </div>
                                            <FormRadio data={NatureEnvois} itemChoisir={nature} setItemChoisir={setNature} name='nature-envoie' />
                                            <div className='side-to-side-envoie'>
                                                <FormInput label='Poids en KG *' itemInput={weight} setItemInput={setWeight} auth />
                                                {
                                                    result !== "" && (
                                                        ((typeEnvoie.id === 1 || typeEnvoie.id === 2) && typeRamassage.id === 1)
                                                            ? (<FormInput label='Cout en Dinars' itemInput={`${result} + Cout Ramassage`} setItemInput={setResult} auth inactive />)
                                                            : (<FormInput label='Cout en Dinars' itemInput={result} setItemInput={setResult} auth inactive />)
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className='button'>
                                        <span className='add' onClick={handleUpdateEnvoie} style={isFetchingUpdate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                            {isFetchingUpdate ? "Modifier Envoie ..." : "Modifier Envoie"}
                                        </span>
                                        <span className='active' onClick={() => navigate('/envois/1')}>Retour</span>
                                    </div>


                                </div>
                            )
                        )
                    )
                }
            </div>
        </div>
    )
}
export default UpdateEnvoie